import { cx } from 'cvb';
import PropTypes from 'prop-types';
import React from 'react';
import { noop } from '../../../utils/noop';
import WithOutsideClick from '../../../utils/WithOutsideClick';
import WithTimeout from '../../../utils/WithTimeout';
import WithTogggle from '../../../utils/WithToggle';
import PopoverStyles from './Popover.style';

const TIMEOUT_MS = 5000;

const Popover = ({
  children,
  content,
  trigger,
  toggleState,
  timer,
  type,
  position,
  dismissOnOutsideClick,
  transparent,
  fullWidth,
  sticky,
}) => {
  const { visible, setVisible } = toggleState;
  const triggerPopoverHandler = (eventType) => {
    if (eventType === trigger) {
      setVisible(true);
      timer.setToggle(true);
    }
  };
  const dismissHandler = () => {
    setVisible(false);
    timer.setToggle(false);
  };

  const popoverContent = (dismiss) => {
    if (typeof content === 'function') {
      return content(dismiss);
    }
    return content;
  };
  return (
    <WithOutsideClick
      onOutsideClick={() => {
        if (dismissOnOutsideClick) {
          dismissHandler();
        }
      }}
      className="overlay-popover"
      styles={PopoverStyles}
    >
      {children}
      <div
        className={cx('popover-container', position, transparent && 'transparent', sticky && 'sticky')}
        onKeyPress={noop}
        onClick={() => triggerPopoverHandler('click')}
        onMouseEnter={() => triggerPopoverHandler('hover')}
        onMouseLeave={() => trigger === 'hover' && dismissHandler()}
        role="menuitem"
        tabIndex="0"
      >
        {visible && timer.toggle && (
          <div className={cx('popover', type, fullWidth && 'fullWidth')}>{popoverContent(dismissHandler)}</div>
        )}
        <style jsx>{PopoverStyles}</style>
      </div>
    </WithOutsideClick>
  );
};

Popover.propTypes = {
  children: PropTypes.node.isRequired,
  content: PropTypes.node.isRequired,
  trigger: PropTypes.oneOf(['click', 'hover', 'none']),
  toggleState: PropTypes.object,
  timer: PropTypes.object,
  type: PropTypes.oneOf(['default', 'compact']),
  position: PropTypes.oneOf(['bottom', 'right', 'center']),
  dismissOnOutsideClick: PropTypes.bool,
  transparent: PropTypes.bool,
  fullWidth: PropTypes.bool,
  sticky: PropTypes.bool,
};
Popover.defaultProps = {
  trigger: 'click',
  position: 'bottom',
  toggleState: null,
  timer: { setToggle: noop, toggle: true },
  type: 'default',
  dismissOnOutsideClick: false,
  transparent: false,
  fullWidth: false,
  sticky: false,
};

const PopoverWithToggle = WithTogggle(Popover);
const PopoverWithTimeout = WithTimeout(PopoverWithToggle, TIMEOUT_MS);

export { PopoverWithTimeout, PopoverWithToggle };
export default Popover;
